import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2528">
      <Navbar data-id="element-2529" />
      <main data-id="element-2530">
        <ConsularAffairs data-id="element-2531" />
      </main>
      <Footer data-id="element-2532" />
      <FeedbackPopup data-id="element-2533" />
    </div>;
}